"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logHonorariumToPlutus = exports.getHonorariumAdvice = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var TIMEOUT = 60000;
var PLUTUS_URL = process.env.REACT_APP_PLUTUS_URL;
var PLUTUS_LOG_URL = process.env.REACT_APP_PLUTUS_LOG_URL;
if (!PLUTUS_URL || !PLUTUS_LOG_URL) {
    throw new Error('Plutus URL not found in env variables');
}
var axiosInstance = axios_1.default.create({
    timeout: TIMEOUT,
    responseType: 'json',
});
axiosInstance.interceptors.response.use(function (response) {
    if (response.data === undefined)
        return response;
    return response.data;
}, function (error) {
    return Promise.reject(error);
});
function getHonorariumAdvice(honorariumData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, axiosInstance.post(PLUTUS_URL, honorariumData)];
        });
    });
}
exports.getHonorariumAdvice = getHonorariumAdvice;
function logHonorariumToPlutus(data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, axiosInstance.post(PLUTUS_LOG_URL, data)];
        });
    });
}
exports.logHonorariumToPlutus = logHonorariumToPlutus;
var api = {
    getHonorariumAdvice: getHonorariumAdvice,
    logHonorariumToPlutus: logHonorariumToPlutus,
};
exports.default = api;
